import {CopilotAssignmentModal} from '@github-ui/agent-sessions/components/copilot-assignment/CopilotAssignmentModal'

import {useCopilotAssignmentModal} from './copilot-assignment-modal-provider'

export const CopilotAssignmentModalRenderer: React.FC = () => {
  const {modalState, closeModal, handleAssignmentComplete} = useCopilotAssignmentModal()

  if (!modalState.repository || modalState.issueNumbers.length === 0) {
    return null
  }

  return (
    <CopilotAssignmentModal
      isOpen={modalState.isOpen}
      onClose={closeModal}
      repository={modalState.repository}
      issueNumbers={modalState.issueNumbers}
      onAssignmentComplete={handleAssignmentComplete}
    />
  )
}

try{ CopilotAssignmentModalRenderer.displayName ||= 'CopilotAssignmentModalRenderer' } catch {}